export default __webpack_public_path__ + "static/media/F0.9d7e2d84.mp3";